<template>
  <security-component />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SecurityComponent from "@/components/Security/Security.vue";

const componentName = "SecurityRoute";

export default defineComponent({
  name: componentName,
  components: { SecurityComponent },
});
</script>
